/*
  Petelite: Bir varyasyon secildiginde musteri buyuk urun fotografini tam gormek istiyor.
  Onceki versiyon sadece galeri kutusunu (.product-gallery) ekrana hizaliyordu, fakat bu
  bazen buyuk fotonun ust kismini kirpip kullaniciyi kucuk gorsellerin/basligin oldugu
  alt kisma yakin birakiyordu. Bunun yerine en guvenilir ve basit cozum: urun sayfasinda
  galeri her zaman sayfanin en ustunde oldugu icin, varyasyon secildiginde tum sayfayi
  (window) en tepeye (0,0) yumusakca kaydiriyoruz. Boylece buyuk foto, baslik, her sey
  tam ve eksiksiz gorunuyor.
  Urun kartlari (koleksiyon sayfalarindaki) ve hizli-ekle pencereleri haric tutulur -
  onlarda sayfa kaydirma istenmiyor.
  Harici bir asset dosyasi olarak yuklenir (inline script degil) ki CSP ile uyumsuzluk
  olmasin.
*/
(function () {
  function isExcludedContext(el) {
    return !!(el.closest('product-card') || el.closest('quick-add-dialog'));
  }

  function scrollPageToTop() {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }

  function handleVariantSelection(sourceElement) {
    try {
      if (!sourceElement || typeof sourceElement.closest !== 'function') return;
      if (isExcludedContext(sourceElement)) return;

      var currentScroll = window.scrollY || document.documentElement.scrollTop || 0;
      // Zaten sayfanin ust kisimlarindaysak (foto zaten gorunur durumdaysa) gereksiz
      // kaydirma yapma.
      if (currentScroll > 40) {
        scrollPageToTop();
      }
    } catch (e) {
      if (window.console && console.warn) console.warn('[petelite-variant-scroll]', e);
    }
  }

  // Yontem 1: variant-picker icindeki input/select'lerden dogal 'change' olayi (en guvenilir yol)
  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var picker = target.closest('variant-picker');
      if (!picker) return;
      handleVariantSelection(picker);
    },
    true
  );

  // Yontem 2: Shopify standart olayi (varsa, yedek olarak)
  function onProductSelect(event) {
    handleVariantSelection(event.target);
  }
  document.addEventListener('shopify:product:select', onProductSelect);
  window.addEventListener('shopify:product:select', onProductSelect);
})();
